// extracted by mini-css-extract-plugin
export var accent = "_2v-4";
export var add = "_2v-j";
export var addIcon = "_2v-k";
export var deleteIcon = "_2v-i";
export var disabled = "_2v-9";
export var ellipsis = "_2v-f";
export var error = "_2v-3";
export var form = "_2v-5";
export var hideFocus = "_2v-2";
export var icon = "_2v-7";
export var input = "_2v-e";
export var listItem = "_2v-h";
export var mediumHeight = "_2v-b";
export var noBorder = "_2v-8";
export var noRadius = "_2v-1";
export var shortHeight = "_2v-a";
export var tallHeight = "_2v-c";
export var textInput = "_2v-0";
export var vertical = "_2v-g";
export var veryTallHeight = "_2v-d";
export var widget = "_2v-6";